/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/rebellion-small': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M16 2.5C8.54 2.5 2.5 8.54 2.5 16S8.54 29.5 16 29.5 29.5 23.46 29.5 16 23.46 2.5 16 2.5zm0 1c6.9 0 12.5 5.6 12.5 12.5S22.9 28.5 16 28.5 3.5 22.9 3.5 16 9.1 3.5 16 3.5z"/><path pid="1" d="M16 5l2.25 7.75 8.25 2.25-9.25.75z"/><path pid="2" d="M14.75 16.25l9.25.75-8.25 2.25L13.5 27z"/><path pid="3" d="M14.5 15.5L5.5 16l8.25-2.25L16 6z"/>'
  }
})
